import Vue from 'vue';

import DSignupModal from '../../components/d-signup-modal/d-signup-modal.vue';

const DSignupModalInstance = Vue.extend(DSignupModal);

class SignupModal {
  constructor() {
    this._signUpModal = null;

    this.createSignupModal();

    this.show = this.show.bind(this);
  }

  createSignupModal() {
    if (this._signUpModal) {
      return;
    }

    this._signUpModal = new DSignupModalInstance();
    this._signUpModal.$mount();
    document.body.append(this._signUpModal.$el);
  }

  hide() {
    this._signUpModal.hide();
  }

  show() {
    this._signUpModal.show();
  }
}


export default {
  install: function(Vue, options) {
    Vue.prototype.signupModal = new SignupModal();
  },
};
